<button class="custom-button" 
        (click)="toggleContainer()"
        [ngClass]="{'border-active': showContainer}"
        >
    <span class="button-text">Select date</span>
    <span class="button-icons">
        <i (click)="toggleContainer()" *ngIf="!showContainer" class="material-icons">expand_more</i>
        <i (click)="toggleContainer()" *ngIf="showContainer" class="material-icons-a">expand_less</i>
    </span>
</button>


<div *ngIf="showContainer" [@showHide]="showContainer ? 'show' : 'hide'">
    <div class="checkbox-tree-container mat-elevation-z8">

    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node
        *matTreeNodeDef="let node"
        matTreeNodeToggle
        matTreeNodePadding
        >
        <button mat-icon-button disabled></button>
        <mat-checkbox
            class="checklist-leaf-node"
            [checked]="checklistSelection.isSelected(node)"
            (change)="todoLeafItemSelectionToggle(node)"
            >{{node.item}}
        </mat-checkbox>
        </mat-tree-node>
    
        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
        <button
            mat-icon-button
            matTreeNodeToggle
            [attr.aria-label]="'Toggle ' + node.item"
        >
            <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
        </button>
        <mat-checkbox
            [checked]="descendantsAllSelected(node)"
            [indeterminate]="descendantsPartiallySelected(node)"
            (change)="todoItemSelectionToggle(node)"
            >{{node.item}}</mat-checkbox
        >
        </mat-tree-node>
    </mat-tree>

    </div>
</div>

  